/**
 * El destino que alguien quiso abrir sin sesión (un enlace compartido), para
 * llevarlo ahí después del login. Vive en la misma llave que ya usa el
 * `appUrlOpen` nativo de `app.component.ts`, así web y app comparten el flujo.
 *
 * Solo se recuerdan las rutas de `RUTAS_RETOMABLES`: muchas pantallas dependen
 * del estado que deja la anterior y no soportan una entrada directa.
 */
export const PENDING_DEEP_LINK_KEY = "pendingDeepLink";

const RUTAS_RETOMABLES: RegExp[] = [
	/^\/isa-drive(\/|\?|$)/,
];

/** Guarda `url` como destino pendiente si es una ruta retomable. */
export function recordarDestino(url: string | null | undefined): void {
	if (!url || !RUTAS_RETOMABLES.some(r => r.test(url))) return;
	localStorage.setItem(PENDING_DEEP_LINK_KEY, url);
}

export function hayDestinoPendiente(): boolean {
	return !!localStorage.getItem(PENDING_DEEP_LINK_KEY);
}

/** Devuelve el destino pendiente y lo borra: se usa una sola vez. */
export function tomarDestinoPendiente(): string | null {
	const url = localStorage.getItem(PENDING_DEEP_LINK_KEY);
	localStorage.removeItem(PENDING_DEEP_LINK_KEY);

	return url || null;
}
